import { render, staticRenderFns } from "./ShipmentInspectEdit.vue?vue&type=template&id=18d73907&scoped=true&"
import script from "./ShipmentInspectEdit.vue?vue&type=script&lang=js&"
export * from "./ShipmentInspectEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentInspectEdit.vue?vue&type=style&index=0&id=18d73907&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d73907",
  null
  
)

export default component.exports